export const DEFAULT = 'default';
export const PAYMENT_V3_URL = customer_id =>
  `/api/v3/customers/${customer_id}/payment_methods/`;
